<template>
    <div class="programme-service-selector">
        <div class="selector-row">
            <div class="selector-item">
                <q-select
                    :model-value="selectedProgramme"
                    :options="programmeOptions"
                    :loading="loadingProgrammes"
                    label="Programme"
                    outlined
                    dense
                    clearable
                    class="selector-field"
                    @update:model-value="updateProgramme"
                />
            </div>

            <div class="or-divider">
                <span class="or-text">OR</span>
            </div>

            <div class="selector-item">
                <q-select
                    :model-value="selectedService"
                    :options="serviceOptions"
                    :loading="loadingServices"
                    label="Service"
                    outlined
                    dense
                    clearable
                    class="selector-field"
                    @update:model-value="updateService"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProgrammeServiceSelector',

    props: {
        selectedProgramme: {
            type: String,
            default: null
        },
        selectedService: {
            type: String,
            default: null
        },
        programmeOptions: {
            type: Array,
            default: () => []
        },
        serviceOptions: {
            type: Array,
            default: () => []
        },
        loadingProgrammes: {
            type: Boolean,
            default: false
        },
        loadingServices: {
            type: Boolean,
            default: false
        },
        exclusive: {
            type: Boolean,
            default: true
        }
    },

    emits: ['update:selectedProgramme', 'update:selectedService'],

    methods: {
        updateProgramme(value) {
            this.$emit('update:selectedProgramme', value);

            if (this.exclusive && value && this.selectedService) {
                this.$emit('update:selectedService', null);
            }
        },

        updateService(value) {
            this.$emit('update:selectedService', value);

            if (this.exclusive && value && this.selectedProgramme) {
                this.$emit('update:selectedProgramme', null);
            }
        }
    }
}
</script>

<style scoped>
.selector-row {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.selector-item {
    flex: 1;
    min-width: 0;
}

.selector-field {
    width: 100%;
}

.or-divider {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.or-text {
    font-size: 0.875rem;
    color: #616161;
    font-weight: 500;
    background: white;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    white-space: nowrap;
}

@media (max-width: 700px) {
    .selector-row {
        flex-direction: column;
        gap: 0.75rem;
    }
}
</style>
